import React, { useState } from 'react';
import './Checkout.css';

function Checkout({ theme, onBackClick, onPlaceOrder }) {
    const [tosAgreed, setTosAgreed] = useState(false);
    const [showTosModal, setShowTosModal] = useState(false);
    const [showCantUnchecked, setShowCantUnchecked] = useState(false);

    const handleTosChange = (e) => {
        if (e.target.checked) {
            setTosAgreed(true);
        } else {
            // Try to uncheck - show error message
            setShowCantUnchecked(true);
            window.setTimeout(() => setShowCantUnchecked(false), 3000);
        }
    };

    const handleTosLink = () => {
        setShowTosModal(true);
    };

    const handleCloseTosModal = () => {
        setShowTosModal(false);
    };

    const handlePlaceOrder = () => {
        if (tosAgreed) {
            onPlaceOrder();
        }
    };

    return (
        <div className={`app ${theme}`}>
            <main>
                <section className="checkout-header-section">
                    <div className="checkout-header">
                        <div>
                            <h1>Checkout</h1>
                            <p className="checkout-subtitle">Please agree to our terms and conditions</p>
                        </div>
                        <button className="back-btn" onClick={onBackClick}>
                            Back to Cart
                        </button>
                    </div>
                </section>

                <section className="checkout-content">
                    <div className="tos-container">
                        <div className="tos-card">
                            <div className="tos-checkbox-wrapper">
                                <div className="giant-checkbox-container">
                                    <input
                                        type="checkbox"
                                        id="tos-checkbox"
                                        checked={tosAgreed}
                                        onChange={handleTosChange}
                                        className="giant-checkbox"
                                    />
                                    <label htmlFor="tos-checkbox" className="checkbox-label">
                                        I agree to the Terms of Service
                                    </label>
                                </div>
                            </div>

                            <p className="tos-link-section">
                                <button
                                    type="button"
                                    className="tos-link-button"
                                    onClick={handleTosLink}
                                >
                                    Click to read Terms of Service
                                </button>
                            </p>

                            {showCantUnchecked && (
                                <div className="cant-uncheck-alert">
                                    <p>You cannot un-agree to your own foolishness.</p>
                                </div>
                            )}
                        </div>

                        <button
                            className="refresh-btn place-order-btn"
                            onClick={handlePlaceOrder}
                            disabled={!tosAgreed}
                        >
                            Place Order
                        </button>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <p>© 2026 StupidDesigns.com. All rights reserved. Not that anyone actually wants them.</p>
            </footer>

            {showTosModal && (
                <div className="tos-modal-overlay" onClick={handleCloseTosModal}>
                    <div className="tos-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="tos-modal-header">
                            <h2>Terms of Service</h2>
                            <button
                                className="tos-modal-close"
                                onClick={handleCloseTosModal}
                                aria-label="Close modal"
                            >
                                ✕
                            </button>
                        </div>
                        <div className="tos-modal-content">
                            <p>
                                By checking this box, you acknowledge that you are attempting to purchase a fictional object, such as Metal Murder Mittens. If we were to actually ship this to you, your cat would legally be allowed to sue you. You also agree that clicking 'Place Order' will do absolutely nothing except consume 40 milliseconds of our database's time.
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Checkout;
